import { AddressRequestModel } from '../models';
import { MatDialogRef } from '@angular/material/dialog';
import { ConfirmationDialogAfterClosedModel } from '../../../../ui-kit';

export class AddressItemLoad {
  public static readonly type = '[AddressItem] Load';

  constructor(public payload: string) {}
}

export class AddressItemCreate {
  public static readonly type = '[AddressItem] Create';

  constructor(public payload: AddressRequestModel) {}
}

export class AddressItemUpdate {
  public static readonly type = '[AddressItem] Update';

  constructor(public payload: AddressRequestModel) {}
}

export class AddressItemDelete {
  public static readonly type = '[AddressItem] Delete';

  constructor(public payload: { dialog: MatDialogRef<ConfirmationDialogAfterClosedModel>; addressId: number }) {}
}

export class AddressItemInitialState {
  public static readonly type = '[AddressItem] Set initial state';
}
